module.exports = __webpack_public_path__ + "img/control_de_calidad_4-3_1024.cd3f4a6b.webp";